
// Question type configuration
export const QUESTION_CONFIG: any = {
    'MC': {
      apiType: 'multiple_choice_question',
      component: {
        answer: 'multiple-choice',
      },
    },
    'MA': {
      apiType: 'multiple_answer_question',
      component: {
        answer: 'multiple-answer',
      },
    },
    'HT_RO': {
      apiType: 'hot_text_reorder_question',
      component: {
        answer: 'reorder',
      },
    },
    'HT_HL': {
      apiType: 'hot_text_highlight_question',
      component: {
        answer: 'hot-text-highlight',
      },
    },
    'T/F': {
      apiType: 'true_false_question',
      component: {
        answer: 'true-false',
      },
    },
    'FIB': {
      apiType: 'fill_in_the_blank_question',
      component: {
        answer: 'fib',
      },
    },
    'HS_IMG': {
      apiType: 'hot_spot_image_question',
      component: {
        answer: 'hs-image',
      },
    },
    'HS_TXT': {
      apiType: 'hot_spot_text_question',
      component: {
        answer: 'hs-text',
      },
    },
    'OE': {
      apiType: 'open_ended_question',
      component: {
        answer: 'open-ended',
      },
    },
    'SE_FIB': {
      apiType: 'scientific_fill_in_the_blank_question',
      component: {
        answer: 'scientific-fib',
      },
    },
    'SE_FRQ': {
      apiType: 'scientific_free_response_question',
      component: {
        answer: 'scientific-free-response',
      },
    },
    'SERP_EA': {
      apiType: 'serp_encoding_assessment_question',
      component: {
        answer: 'encoding-assessment',
      },
    },
    'SERP_DA': {
      apiType: 'serp_decoding_assessment_question',
      component: {
        answer: 'decoding-assessment',
      },
    },
    'SERP_SOL': {
      apiType: 'serp_lang_say_out_loud_question',
      component: {
        answer: 'say-out-loud',
      },
    },
    'SERP_ID': {
      apiType: 'serp_lang_identify_digraph_question',
      component: {
        answer: 'identify-digraph',
      },
    },

    'SERP_WPM': {
      apiType: 'serp_words_per_minute_question',
      component: {
        answer: 'words-per-minute',
      },
    },
    'SERP_SR': {
      apiType: 'serp_silent_reading_question',
      component: {
        answer: 'silent-reading',
      },
    },
    'SERP_PCR': {
      apiType: 'serp_phrase_cued_reading_question',
      component: {
        answer: 'phrase-reading',
      },
    },
    'SERP_AFC': {
      apiType: 'serp_lang_activities_for_comprehension_question',
      component: {
        answer: 'comprehension',
      },
    },
    'SERP_IB': {
      apiType: 'serp_lang_identify_base_word_question',
      component: {
        answer: 'basword',
      },
    },
    'SERP_VT': {
      apiType: 'serp_lang_vowel_teams_question',
      component: {
        answer: 'vowel-teams',
      },
    },
    'SERP_CS': {
      apiType: 'serp_lang_counting_syllables_question',
      component: {
        answer: 'counting-syllables',
      },
    },
    'SERP_SD': {
      apiType: 'serp_lang_syllable_division_question',
      component: {
        answer: 'syllables-division',
      },
    },
  };

  // Question Types
export const QUESTION_TYPES = {
  multipleChoice: 'MC',
  multipleAnswer: 'MA',
  trueFalse: 'T/F',
  openEnded: 'OE',
  fib: 'FIB',
  hotSpotText: 'HS_TXT',
  hotSpotImage: 'HS_IMG',
  hotTextReorder: 'HT_RO',
  hotTextHighlight: 'HT_HL',
  scientificfib: 'SE_FIB',
  scientificFreeResponse: 'SE_FRQ',
  encodingAssessment: 'SERP_EA',
  decodingAssessment: 'SERP_DA',
  sayOutLoud: 'SERP_SOL',
  identifyDigraph: 'SERP_ID',
  readingQuestion: 'SERP_RQ',
  wordsPerMinute: 'SERP_WPM',
  silentReading: 'SERP_SR',
  phraseCuedReading: 'SERP_PCR',
  comprehension: 'SERP_AFC',
  vowelsQuestions: 'SERP_VOWELS',
  countingSyllable: 'SERP_CS',
  baseWords: 'SERP_IB',
  vowelTeams: 'SERP_VT',
  dividingSyllables: 'SERP_SD',
};

export function getComponent(type: any) {
  const selectedQuestion = QUESTION_CONFIG[type] ? QUESTION_CONFIG[type] : null;
  const component = selectedQuestion && selectedQuestion.component
                         ? selectedQuestion.component.answer : null;
  return component;
}

export function toFibText(text: any) {
  if (text) {
    const inputText = '_______';
    const regExp = /(.{4})?(\[[^[\]]+])/gi;
    const replacer = (match: any, p1: any /*, p2, offset, text*/) => {
      const replace = p1 === undefined || p1 !== 'sqrt';
      const newText = p1 === undefined ? inputText : `${p1}${inputText}`;
      return replace ? newText : match;
    };
    text = text.replace(regExp, replacer);
  }
  return text;
}


/**
 * Returns resource name with a protocol if it is necessary
 * @param {String} url
 * @param {boolean} addSecureProtocol
 */
export function addProtocolIfNecessary(url: any, addSecureProtocol: any) {
  const pattern = /^((http|https|ftp):\/\/)/;
  let protocol = 'http:';

  if (!pattern.test(url)) {
    // if no protocol add http/https
    if (addSecureProtocol) {
      protocol = 'https:';
    }
    return protocol + url;
  }

  return url;
}
